/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * API
 * OpenAPI spec version: 1.0.0
 */

export type GetApiCustomerGroupsCampaignType =
    (typeof GetApiCustomerGroupsCampaignType)[keyof typeof GetApiCustomerGroupsCampaignType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApiCustomerGroupsCampaignType = {
    EMAIL: 'EMAIL',
    SMS: 'SMS',
} as const;
